import Vue from 'vue'
import Vuex from 'vuex'
const ls = require('local-storage')
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cropImg: '',
    classeTur: '',
    turmaPage: '',
    navPageToGo: '',
    navPageToBack: '',
    isloading: false,
    lancarNotaDe: '',
    idperfilpauta: 0,
    versugestao: false,
    showDialogoSugestao: false,
    fromMinhaTurmas: false,
    disciplina: '',
    idclasse: 0,
    loggedUser: [],
    instituicaodescricao: ls.get('instituicaodescricao'),
    textMessage: '',
    classMessage: 'msgWorning',
    hasMessage: false,
    objturma: null,
    anoAcademico: 0,
    anolectivoSelected: null,
    mudarSenha: false,
    anoLectivo: 0,
    objcadeira: null,
    bloqueado: [],
    turmasNotas_Admin: [],
    anolectivoNotaAdmin: 0,
    Controlopauta: 0,
    objaluno: null,
    componentepauta: { geral: false},
    showDialogGuia: { cartao: false, carta: false, declaracao: false, declaracao_nota: false, ficha: false, guia: false, historico: false, listaestudante: false, estatistica: false, planificacaoEstatistica: false, boletim: false,declaracao_aproveitamento:false,
      mapacontrolavaliacaocontinua: { menu: false, componente: false },
      mapacontroltrimestral: { menu: false, componente: false }    
    },
    actividades: [],
    fromPrepararCertificado: false,
    fromPesquisaFinalista: false,
    anolectivoSelecionado: null,
    anolectivoLancamento: null,
    novadescricaoSelecionado: '',
    config_estudante_instituicao: [],
    emitirCertificado: 0,
    mudarturma: false,
    certificado: 0,
    mensagem: null,
    objPauta: null,
    rotas: null,
    Pautas: [],
    minipauta: [],
    objEstudante: null,
    objDisciplina: null,
    listEstudantfromPauta: [],
    backTo: null,
    tabPerfil: null,
    provincia: null,
    municipio: null,
    fromMenu: null,
    tipoimpressao: null,
    impressaoTelaEstudante: false,
    objSolicitacao: null

  },
  getters: {
    loggedUser (state) {
      return ls.get('token') // axios.js envia para api
    },

    resetObjSolicitacao(){
      objSolicitacao = null
    }
  },
  mutations: {

     SET_VERSUGESTAO(state, valor) {
      state.versugestao = valor;
    },

    setObjAluno(state, objAluno) {
    state.objAluno = objAluno
  },

    SET_MUDARTURMA(state, valor) {
      state.mudarturma = valor;
    },

    SET_DIALOGOUGESTAO(state, valor) {
      state.showDialogoSugestao = valor;
    },
     SET_MUDARSENHA(state, valor) {
      state.mudarSenha = valor;
    },

    setMessage(state, { text, type = 'info' }) {
    state.hasMessage = true
    state.textMessage = text
    state.classMessage = type
  },
  clearMessage(state) {
    state.hasMessage = false
    state.textMessage = ''
    state.classMessage = ''
  },

    lancarNotaDe (state, payload) {
      state.lancarNotaDe = payload[0].param
      state.idperfilpauta = payload[0].idperfilpauta
    },
    textMessage (state, payload) {
      state.textMessage = payload.msg
      state.hasMessage = true
      setTimeout(() => {
        state.hasMessage = false
        state.textMessage = ''
        state.classMessage = 'msgWorning'
      }, payload.timeout)// hide worning and initialize msg  props
    },
    classMessage (state, classMessage) {
      state.classMessage = classMessage
    },
    loggedUser (state, user) {
    }
  },
  actions: {

    lancarNotaDe (context, payload) {
      context.commit('lancarNotaDe', payload)
    },
    textMessage (context, payload) {
      context.commit('classMessage', payload.classMessage)
      context.commit('textMessage', payload)
    },

    toggleSugestao({ commit }, valor) {
      commit('SET_VERSUGESTAO', valor);
    },

    toggleMudarTurma({ commit }, valor) {
      commit('SET_MUDARTURMA', valor);
    },

    toggleMudarSenha({ commit }, valor) {
      commit('SET_MUDARSENHA', valor);
    },
    

    toggleDialogSugestao({ commit }, valor) {
      commit('SET_DIALOGOUGESTAO', valor);
    },

    loggedUser (context, user) {
      ls.set('token', user.token) // token enviado axios.js   tudo automatico
      ls.set('tokenMaster', user.tokenMaster)
      ls.set('role', user.role)
      ls.set('sigla', user.sigla)
      ls.set('i_id', user.instituicao)
      ls.set('nomeUsuario', user.nomeUsuario)
      ls.set('idanolectivo', user.idanolectivo)
      ls.set('novadescricao', user.novadescricao)
      ls.set('idPessoa', user.idPessoa)
      ls.set('anolectivo', user.anolectivo)
      ls.set('instituicaodescricao', user.instituicaodescricao)
      ls.set('uuid', user.uuid)
      ls.set('lista_actividades', user.actividades)
      ls.set('username', user.username)
      ls.set('mudarPassword', user.mudarPassword)
      ls.set('dataExpiracao', user.dataExpiracao)
      ls.set('usuarios_permitidos', user.usuarios_permitidos)
      ls.set('telefone', user.telefone)
      ls.set('pkUsuario', user.pkUsuario)
      ls.set('dataUser', user.dataUser)
      ls.set('closePublicidade', true)
      ls.set('logged_date_control', user.logged_date_control)
      ls.set("nivel_user", user.nivel_user)
      ls.set('publicity', user.publicity)
      ls.set('anuncio',true)
      ls.set('idLoginLogs',user.idLoginLogs)
      ls.set('isintegrado',user.isintegrado)
      ls.set('ims', user.ims)
      ls.set('showPublicity', true)
      ls.remove('fatal')
      ls.set('photo', user.foto)
      ls.set('dataExpiracao', user.dataExpiracao)
      ls.set('dataActual', user.dataActual)
      
     }
  }
})
